/* Copyright (c) Epiphyte LLC 2022. All rights reserved.
Author: Fernandez-Alcon, Jose <jose@epiphyte.io>
 */

import React, {useState} from "react";
import {
    Accordion,
    AccordionPanel,
    Card,
    Button,
    CardBody,
    CardHeader,
    CardFooter,
    Paragraph,
    Form,
    Text,
    Heading,
    Image,
    Menu, Layer, Box, FormField, TextInput, TextArea,
} from "grommet";
import { Edit, Trash } from 'grommet-icons'
import {
    deleteProduce
} from "API/API";
import SendMessage from "Components/Messaging/SendMessage";


type Props = {
    refreshFunc: () => {},
    Image: string,
    Title: string,
    Description: string,
    ProduceID: string,
}

const SearchProduceCard: React.FC<Props> = (props) => {
    const [showModal, setShowModal] = useState<boolean>(false)
    const [message, setMessage] = useState({})
    const [messageBody, setMessageBody] = useState<string>("")

    console.log(props.Image)
    // const image = "https://images.unsplash.com/photo-1522184216316-3c25379f9760?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=3870&q=80"

    const sendMessage = (message) => {
        setShowModal(false)
    }

    return (
        <>
        <Card
            width={"medium"}
            onClick={() => setShowModal(true)}
        >
            <CardHeader>
                <Image
                    fit="cover"
                    src={"https://produceimages.vegg.it/"+ props.Image}// src={props.Image}
                />
            </CardHeader>
            <CardBody
                pad={"small"}
            >
                <Heading
                    color={"brand"}
                    level={3}
                >{props.Title}</Heading>
                <Paragraph>
                    {props.Description}
                </Paragraph>
            </CardBody>

        </Card>


    {showModal && (
        <Layer
            onEsc={() => setShowModal(false)}
            onClickOutside={() => setShowModal(false)}
            modal={true}
            animate={true}

        >
            <Box
                width={"large"}
                pad={"medium"}
            >
                <Image
                    fit="cover"
                    src={"https://produceimages.vegg.it/"+ props.Image}// src={props.Image}
                />
                <Heading
                    color={"brand"}
                    level={3}
                >{props.Title}</Heading>
                <Paragraph>
                    {props.Description}
                </Paragraph>
                <Accordion>
                    <AccordionPanel label="Contact Producer">
                        <Box pad="medium" background="light-2">
                            <Form
                                value={message}
                                onChange={nextValue => setMessage(nextValue)}
                                onReset={() => setMessage({})}
                                onSubmit={({ value }) => {sendMessage(value)}}
                            >
                                <FormField name="Subject" htmlFor="text-input-title" label="Subject">
                                    <TextInput id="text-input-title" name="Subject" />
                                </FormField>
                                <FormField name="MessageBody" htmlFor="text-input-description" label="Message">
                                    <TextArea
                                        fill={true}
                                        placeholder="Your message to the producer"
                                        onChange={event => setMessageBody(event.target.value)}
                                    />
                                </FormField>
                                <Box direction="row" gap="medium">
                                    <Button type="submit" primary label="Send Message" />
                                    <Button type="reset" label="Cancel" />
                                </Box>
                            </Form>
                        </Box>
                    </AccordionPanel>
                </Accordion>
            </Box>
        </Layer>
    )}
        </>
    )

}

export default SearchProduceCard
